/**
 * Common UI labels used across multiple modules
 * These are default labels that can be overridden per company
 */
export const COMMON_LABELS = {
  location: "Location",
  locationAddress: "Location Address",
  locationName: "Location Name",
  locations: "Locations",
  addLocation: "Add Location",
  createLocation: "Create Location",
  editLocation: "Edit Location",
  client: "Client",
  clients: "Clients",
  clientAddress: "Client Address",
  clientName: "Client Name",
  addClient: "Add Client",
  createClient: "Create Client",
  editClient: "Edit Client",
  address: "Address",
  name: "Name",
  description: "Description",
  status: "Status",
  date: "Date",
  time: "Time",
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  create: "Create",
  update: "Update",
  search: "Search",
  enterToSearch: "Enter to search..",
  filter: "Filter",
  reset: "Reset",
  submit: "Submit",
  close: "Close",
  back: "Back",
  next: "Next",
  previous: "Previous",
  loading: "Loading...",
  noResults: "No results found",
  error: "Error",
  success: "Success",
  phoneNumber: "Phone number",
  email: "Email",
  password: "Password",
  socials: "Socials",
  moreDetail: "More Detail",
  profile: "Profile",
  siteNumber: "Site Number",
  refresh: "Refresh",
  editDelete: "Edit Delete",
  restore: "Restore",
  successfullyDeleted: "Successfully deleted",
  filterBy: "Filter By",
  city: "City",
  state: "State",
  zip: "Zip",
  fullName: "Full Name",
  id: "ID",
  title: "Title",
  contactName: "Contact Name",
  phonenumber: "Phonenumber",
  add: "Add",
  // Sidebar menu labels
  dashboard: "Dashboard",
  workMenu: "Work Menu",
  createNewWork: "Create New Work",
  workCalendar: "Work Calendar",
  workManagement: "Work Management",
  templates: "Templates",
  independentProfessionals: "Independent Professionals",
  showList: "Show List",
  showMap: "Show Map",
  favorites: "Favorites",
  finances: "Finances",
  generalFinances: "General Finances",
  financialReport: "Financial Report",
  settings: "Settings",
  addManagers: "Add Managers",
  uiWording: "UI Wording",
  // Error and validation messages
  thisFieldIsRequired: "This field is required",
  locationIsRequired: "Location is required",
  managerIsRequired: "Manager is required",
  invalid: "Invalid",
  pleaseSetValidDateAndTime: "Please set a valid date and time",
  // Success messages
  workCreated: "Work created",
  workUpdated: "Work updated",
  layoutPreferencesSaved: "Layout preferences saved successfully!",
  failedToSavePreferences: "Failed to save preferences",
  // Validation messages
  enteredValueDoesNotMatchEmailFormat: "Entered value does not match email format",
  // Tooltip labels
  filterList: "Filter list",
} as const;

export type CommonLabelKey = keyof typeof COMMON_LABELS;
